import humanize from "humanize-duration";
import moment from "moment";

const DAY = 1000 * 60 * 60 * 24;

const format = (date) => {
    const s = date.toISOString(); // e.g. "2020-08-26T00:00:00.000Z"
    return s.substring(0, s.length - 1); // strip trailing 'Z'
};

export const toDayStart = (dateStr) => {
    const t = Date.parse(dateStr);
    const d = new Date(t - (t % DAY)); // lop off the day's remainder
    return format(d);
};

export const toDayEnd = (dateStr) => {
    const t = Date.parse(dateStr);
    const d = new Date(t - (t % DAY) + DAY - 1);
    return format(d);
};

export const offsetDateStr = (dateStr, amountMs = 0) => {
    // const t = Date.parse(dateStr);
    // const d = new Date(t + amountMs);
    const d = moment(dateStr).add(amountMs, "milliseconds");
    return format(d);
};

export const getDateMDY = (date) => {
    const dateParts = date.split("/");
    return new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
};

export const formatDurationMinutes = (m) => {
    return humanize(m * 60 * 1000);
};

export const PERIOD_OPTIONS = [
    {
        label: "Yesterday",
        value: "Yesterday",
    },
    {
        label: "This Week",
        value: "ThisWeek",
    },
    {
        label: "Last Week",
        value: "LastWeek",
    },
    {
        label: "This Month",
        value: "ThisMonth",
    },
    {
        label: "Last Month",
        value: "LastMonth",
    },
    {
        label: "This Quarter",
        value: "ThisQuarter",
    },
    {
        label: "Last Quarter",
        value: "LastQuarter",
    },
    {
        label: "This Year",
        value: "ThisYear",
    },
    {
        label: "Last Year",
        value: "LastYear",
    },
    {
        label: "Custom Date",
        value: "Custom",
    },
];

export const TIME_OPTIONS = [
    {
        label: "~09:00",
        value: "BeforeNineAM",
    },
    {
        label: "09:00-10:00",
        value: "NineToTenAM",
    },
    {
        label: "10:00-11:00",
        value: "TenToElevenAM",
    },
    {
        label: "11:00-12:00",
        value: "ElevenToTwelveNoon",
    },
    {
        label: "12:00-13:00",
        value: "NoonToOnePM",
    },
    {
        label: "13:00-14:00",
        value: "OnePMToTwoPM",
    },
    {
        label: "14:00-15:00",
        value: "TwoPMToThreePM",
    },
    {
        label: "15:00-16:00",
        value: "ThreePMToFourPM",
    },
    {
        label: "16:00-16:30",
        value: "FourPMtoFourThirtyPM",
    },
    {
        label: "16:30+",
        value: "FourThirtyPMToEOD",
    },
    {
        label: "Custom Time",
        value: "Custom",
    },
];

export const getCurrentDate = () => {
    const date = new Date();
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    return `${day}-${month}-${year}`;
};

export const shouldPasswordExpirationToastshowup = () => {
    const daysLeftForPasswordExpiration = Number(
        localStorage.getItem("daysLeftForPasswordExpiration")
    );
    return (
        localStorage.getItem("passwordExpirationCheckedOn") !==
            getCurrentDate() &&
        daysLeftForPasswordExpiration > 0 &&
        daysLeftForPasswordExpiration <= 14
    );
};

export const getDateRange = (periodValue, format) => {
    let startDate = null;
    let endDate = null;
    const dateFormat = format ? format : "YYYY-MM-DD";

    switch (periodValue) {
        case "Yesterday":
            startDate = moment()
                .subtract(1, "day")
                .startOf("day")
                .format(dateFormat);
            endDate = moment()
                .subtract(1, "day")
                .endOf("day")
                .format(dateFormat);
            break;
        case "ThisWeek":
            startDate = moment().startOf("week").format(dateFormat);
            endDate = moment().endOf("week").format(dateFormat);
            break;
        case "LastWeek":
            startDate = moment()
                .subtract(1, "week")
                .startOf("week")
                .format(dateFormat);
            endDate = moment()
                .subtract(1, "week")
                .endOf("week")
                .format(dateFormat);
            break;
        case "ThisMonth":
            startDate = moment().startOf("month").format(dateFormat);
            endDate = moment().endOf("month").format(dateFormat);
            break;
        case "LastMonth":
            startDate = moment()
                .subtract(1, "month")
                .startOf("month")
                .format(dateFormat);
            endDate = moment()
                .subtract(1, "month")
                .endOf("month")
                .format(dateFormat);
            break;
        case "ThisQuarter":
            startDate = moment().startOf("quarter").format(dateFormat);
            endDate = moment().endOf("quarter").format(dateFormat);
            break;
        case "LastQuarter":
            startDate = moment()
                .subtract(1, "quarter")
                .startOf("quarter")
                .format(dateFormat);
            endDate = moment()
                .subtract(1, "quarter")
                .endOf("quarter")
                .format(dateFormat);
            break;
        case "ThisYear":
            startDate = moment().startOf("year").format(dateFormat);
            endDate = moment().endOf("year").format(dateFormat);
            break;
        case "LastYear":
            startDate = moment()
                .subtract(1, "year")
                .startOf("year")
                .format(dateFormat);
            endDate = moment()
                .subtract(1, "year")
                .endOf("year")
                .format(dateFormat);
            break;
        default:
            // Handle 'Custom' case or other custom logic if needed
            break;
    }

    return { startDate, endDate };
};
